import script from "./OSSCorrectionProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./OSSCorrectionProjects.vue?vue&type=script&setup=true&lang=js"

import "./OSSCorrectionProjects.vue?vue&type=style&index=0&id=6f81ab32&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./OSSCorrectionProjects.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f81ab32"]])

export default __exports__